module.exports = __webpack_public_path__ + "static/media/CMC.1036df4d.svg";